import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthUser, selectOnboardingPending } from '../store/selectors.js';
import { resolveOnboardingPending } from '../lib/onboardingStatus.js';

export function RequireOnboarding() {
  const onboardingPending = useSelector(selectOnboardingPending);
  const user = useSelector(selectAuthUser);
  const effectiveOnboardingPending = resolveOnboardingPending({ onboardingPending, user });

  if (!effectiveOnboardingPending) {
    return <Navigate to="/courses" replace />;
  }

  return <Outlet />;
}
